<template>
  <div>
    <div class="section">Details</div>
    <!-- begin widget-list -->
    <div class="widget-list rounded mb-4">
      <!-- begin widget-list-item -->
      <div class="widget-list-item">
        <div class="widget-list-media text-grey">
          <i class="fas fa-school fa-2x"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">
            Event: {{ photoItem ? photoItem.event_name : '-' }}
          </h4>
          <p class="widget-list-desc">
            {{ photoItem ? photoItem.event_date : '-' }}
          </p>
        </div>
      </div>
      <div class="widget-list-item">
        <div class="widget-list-media text-grey">
          <i class="fas fa-user-graduate fa-2x"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">
            Student:
            {{ photoItem ? photoItem.full_name_en : '-' }}
          </h4>
          <p class="widget-list-desc">
            {{ photoItem ? photoItem.class_name : '-' }}
          </p>
        </div>
      </div>
      <div class="widget-list-item">
        <div class="widget-list-media text-grey">
          <i class="fas fa-file fa-2x"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">
            File:
            {{ photoItem ? photoItem.original_file_name : '-' }}
          </h4>
          <p class="widget-list-desc">
            {{ photoItem ? photoItem.size_text : '-' }}
          </p>
        </div>
      </div>
      <div class="widget-list-item">
        <div class="widget-list-media text-grey">
          <i class="fas fa-calendar-check fa-2x"></i>
        </div>
        <div class="widget-list-content">
          <h4 class="widget-list-title">
            {{ photoItem ? photoItem.photo_uploaded_date : '-' }}
          </h4>
          <p class="widget-list-desc">
            {{ photoItem ? photoItem.photo_uploaded_by : '-' }}
          </p>
        </div>
      </div>
      <!-- end widget-list-item -->
    </div>
    <!-- end widget-list -->
  </div>
</template>
<script>
export default {
  name: '',
  props: ['photoItem']
}
</script>

<style scoped>
.section {
  color: rgb(95, 99, 104);
  display: flex;
  padding: 14px 0;
  font-family: Roboto, Arial, sans-serif;
  line-height: 1rem;
  font-size: 0.6875rem;
  letter-spacing: 0.0727272727em;
  font-weight: 500;
  text-transform: uppercase;
}
</style>
